var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 17.6H2L1 17.2V10H17.5V10.8V11.2L18 12V13.2L17.5 15.6V17.2L14 18L5.5 17.6Z",
    fill: "#ADCCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.27116C1 7.83293 1 7.11382 1.33327 6.48171C1.66655 5.8496 2.29244 5.38161 3.54423 4.44562L4.75852 3.53768C7.02112 1.84589 8.15242 1 9.5 1C10.8476 1 11.9789 1.84589 14.2415 3.53768L15.4558 4.44562C16.7076 5.38161 17.3335 5.8496 17.6667 6.48171C18 7.11382 18 7.83293 18 9.27116V13.7629C18 15.7602 18 16.7589 17.2887 17.3794C16.5774 17.9999 15.4325 17.9999 13.1429 17.9999H5.85714C3.56746 17.9999 2.42262 17.9999 1.71131 17.3794C1 16.7589 1 15.7602 1 13.7629V9.27116Z",
    stroke: "#0D57D1",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5357 18V12.6444C12.5357 12.0921 12.0879 11.6444 11.5357 11.6444H7.46423C6.91195 11.6444 6.46423 12.0921 6.46423 12.6444V18",
    stroke: "#0D57D1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIcon);
export default __webpack_public_path__ + "static/media/DashIcon.4b90b854ecf5218fa34fb738d5742d01.svg";
export { ForwardRef as ReactComponent };